import { ReportView } from "../../praxis-call/components/ReportView";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../../services/api";
import { useParams, useLocation } from "react-router-dom";
import { LottieLoading } from "../../../components/Loading/LottieLoading";

export function SessionReportDetails() {
  const { sessionID } = useParams();
  const location = useLocation();
  const isFromHistory = location.state?.source === "history";

  const { data: fullReportData, isLoading: isLoadingFullReport } = useQuery({
    queryKey: ["full-report", sessionID],
    queryFn: () => api.fetchReport(sessionID!, undefined),
    enabled: !!sessionID,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const { data: detailedReportData } = useQuery({
    queryKey: ["detailed-report", sessionID],
    queryFn: () => api.getDetailedReport(sessionID!),
    enabled: !!sessionID,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const reportToDisplay = fullReportData?.data?.report ? {
    ...fullReportData?.data?.report,
    session: {...(fullReportData?.data?.session || {}), sessionID},
  } : undefined;

  const detailedReport = detailedReportData?.data ? {
    ...detailedReportData?.data,
    session: {...(fullReportData?.data?.session || {}), sessionID},
  } : undefined;

  if (isLoadingFullReport || !reportToDisplay) {
    return (
      <div className="flex items-center justify-center h-screen">
        <LottieLoading />
      </div>
    );
  }

  return (
    <ReportView
      report={reportToDisplay}
      isReport={true}
      detailedReport={detailedReport}
      ifFromDashboard={!isFromHistory}
      showTutorial={true}
      showCompactFeedback={true}
    />
  );
}
